import AdmissionPRP from "@/views/DemandeAdmissionPRP.vue";
import RenseignementsGeneraux from "@/components/DemandeAdmissionPRP/RenseignementsGeneraux.vue";
import AutorisationDePratique from "@/components/DemandeAdmissionPRP/AutorisationDePratique.vue";
import DeclarationsObligatoires from "@/components/DemandeAdmissionPRP/DeclarationsObligatoires.vue";
import ExperienceProfessionnelle from "@/components/DemandeAdmissionPRP/ExperienceProfessionnelle.vue";
import NoteAdditionnelle from "@/components/DemandeAdmissionPRP/NoteAdditionnelle.vue";
import Formations from "@/components/DemandeAdmissionPRP/Formations.vue";
import Scolarite from "@/components/DemandeAdmissionPRP/Scolarite.vue";

const routeName = "DemandeAdmissionPRP";

export default [
  {
    path: "/demande-admission/prp",
    name: "DemandeAdmissionPRP",
    component: AdmissionPRP,
    meta: {
      title: "Admission PRP | OTSTCFQ",
    },
    props: {
      routeName: routeName,
    },
    children: [
      {
        path: "renseignements-generaux",
        name: `${routeName}/RenseignementsGeneraux`,
        component: RenseignementsGeneraux,
      },
      {
        path: "autorisation-de-pratique",
        name: `${routeName}/AutorisationDePratique`,
        component: AutorisationDePratique,
      },
      {
        path: "formations",
        name: `${routeName}/Formations`,
        component: Formations,
      },
      {
        path: "declarations-obligatoires",
        name: `${routeName}/DeclarationsObligatoires`,
        component: DeclarationsObligatoires,
      },
      {
        path: "experience-professionnelle",
        name: `${routeName}/ExperienceProfessionnelle`,
        component: ExperienceProfessionnelle,
      },
      {
        path: "scolarite",
        name: `${routeName}/Scolarite`,
        component: Scolarite,
      },
      {
        path: "note-additionnelle",
        name: `${routeName}/NoteAdditionnelle`,
        component: NoteAdditionnelle,
      },
    ],
  },
];